import { useEffect, useState } from 'react'
import { referencesAPI } from '../../services/api'
import { Loading } from '../Common/Loading'
import { Trash2, Edit2 } from 'lucide-react'
import { Button } from '../Common/Button'
import toast from 'react-hot-toast'

export const ReferenceList = ({ referenceType }) => {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [searchQuery, setSearchQuery] = useState('')

  useEffect(() => {
    fetchItems()
  }, [referenceType])

  const fetchItems = async () => {
    try {
      setLoading(true)
      const response = await referencesAPI.list(referenceType, searchQuery)
      setItems(response.data || [])
    } catch (error) {
      toast.error('Ошибка загрузки справочника')
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (itemId) => {
    if (!window.confirm('Вы уверены?')) return

    try {
      await referencesAPI.delete(referenceType, itemId)
      setItems(items.filter(item => item.id !== itemId))
      toast.success('Запись удалена')
    } catch (error) {
      toast.error('Ошибка удаления')
    }
  }

  if (loading) return <Loading message="Загрузка справочника..." />

  const columns = {
    materials: ['name', 'code', 'unit', 'price'],
    equipment: ['name', 'code', 'category', 'price_per_hour'],
    operations: ['name', 'code', 'unit', 'price']
  }

  const columnLabels = {
    name: 'Наименование',
    code: 'Код',
    unit: 'Единица',
    price: 'Цена',
    category: 'Категория',
    price_per_hour: 'Цена/час'
  }

  const visibleColumns = columns[referenceType] || []

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b">
        <input
          type="text"
          placeholder="Поиск..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value)
            fetchItems()
          }}
          className="w-full px-4 py-2 border rounded-lg"
        />
      </div>

      {items.length === 0 ? (
        <div className="p-6 text-center text-gray-500">
          Нет записей в справочнике
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                {visibleColumns.map(col => (
                  <th
                    key={col}
                    className="px-6 py-3 text-left text-sm font-medium text-gray-700"
                  >
                    {columnLabels[col]}
                  </th>
                ))}
                <th className="px-6 py-3 text-left text-sm font-medium text-gray-700">
                  Действия
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.id} className="border-t hover:bg-gray-50">
                  {visibleColumns.map(col => (
                    <td
                      key={col}
                      className="px-6 py-4 text-sm text-gray-900"
                    >
                      {typeof item[col] === 'number'
                        ? item[col].toFixed(2)
                        : item[col]}
                    </td>
                  ))}
                  <td className="px-6 py-4 text-sm">
                    <div className="flex gap-2">
                      <Button
                        variant="secondary"
                        size="sm"
                        className="flex items-center gap-1"
                      >
                        <Edit2 size={14} />
                        Редактировать
                      </Button>
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => handleDelete(item.id)}
                        className="flex items-center gap-1"
                      >
                        <Trash2 size={14} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
